import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { QueueLimitsView } from './helpers';

interface IProps {
  view: QueueLimitsView;
  onChange: (view: QueueLimitsView) => void;
}

const SegmentedControl: React.FC<IProps> = ({ view, onChange }) => {
  const { t } = useTranslation();

  const tabs: { key: QueueLimitsView; label: string }[] = [
    { key: 'grid', label: t('queueLimits.tabs.hourGrid') },
    { key: 'table', label: t('queueLimits.tabs.windows') },
    { key: 'day', label: t('queueLimits.tabs.byDay') },
  ];

  return (
    <div className={s.segmented}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          data-cy={`queue-limits-view-${tab.key}`}
          className={classNames(s.segButton, {
            [s.segButtonActive]: view === tab.key,
          })}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default SegmentedControl;
